import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { BuslineQueryData } from '@area-restrita/api-client/model/buslineQueryData';

import ChecklistBadge from '@/components/ChecklistBadge';

import { getChecklistDisplay } from './getChecklistDisplay';

type IProps = CellContext<BuslineQueryData, unknown>;

const ChecklistCell: React.FC<IProps> = ({ row }) => {
  const display = getChecklistDisplay(row.original);

  if (display.type !== 'default') {
    return <ChecklistBadge label={display.label} />;
  }

  return (
    <ChecklistBadge
      label={display.label}
      tooltip={`Checklist padrão: ${display.checklistName}`}
    />
  );
};

export default ChecklistCell;
